var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "info-item",
        {
          attrs: {
            isEnabled: _vm.isEnabled,
            label: _vm.resource("DmVisualizer_ChangeInfo_Address")
          },
          on: {
            "set-enabled": function($event) {
              return _vm.$emit("set-enabled", $event)
            }
          }
        },
        [
          _c("info-text-input", {
            attrs: {
              label: _vm.resource("Address_Street"),
              placeholder: _vm.resource(
                "DmVisualizer_ChangeInfo_Placeholder_Street"
              ),
              isEnabled: _vm.isEnabled,
              scale: [2, 10],
              value: _vm.street
            },
            on: {
              input: function($event) {
                return _vm.$emit("update:street", $event)
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("info-text-input", {
                  attrs: {
                    label: _vm.resource("Address_Zipcode"),
                    placeholder: _vm.resource(
                      "DmVisualizer_ChangeInfo_Placeholder_Zipcode"
                    ),
                    isEnabled: _vm.isEnabled,
                    scale: [4, 8],
                    value: _vm.zipcode
                  },
                  on: {
                    input: function($event) {
                      return _vm.$emit("update:zipcode", $event)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("info-text-input", {
                  attrs: {
                    label: _vm.resource("Address_HouseNo"),
                    placeholder: _vm.resource(
                      "DmVisualizer_ChangeInfo_Placeholder_HouseNo"
                    ),
                    isEnabled: _vm.isEnabled,
                    scale: [7, 5],
                    value: _vm.houseNo
                  },
                  on: {
                    input: function($event) {
                      return _vm.$emit("update:houseNo", $event)
                    }
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("info-text-input", {
            attrs: {
              label: _vm.resource("Address_City"),
              placeholder: _vm.resource(
                "DmVisualizer_ChangeInfo_Placeholder_City"
              ),
              isEnabled: _vm.isEnabled,
              scale: [2, 10],
              value: _vm.city
            },
            on: {
              input: function($event) {
                return _vm.$emit("update:city", $event)
              }
            }
          }),
          _vm._v(" "),
          _c("info-text-input", {
            attrs: {
              label: _vm.resource("Address_Country"),
              placeholder: _vm.resource(
                "DmVisualizer_ChangeInfo_Placeholder_Country"
              ),
              isEnabled: _vm.isEnabled,
              scale: [2, 10],
              value: _vm.country
            },
            on: {
              input: function($event) {
                return _vm.$emit("update:country", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }